<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{ element_group && element_group.data.attributes.name }}</h1>
    </div>
    <div class="tabs">
      <div class="wrapper-x-40">
        <router-link
          :class="{ active: true }"
          class="focus:outline-none"
          :to="{
            name: 'engravings',
            params: { slug: $route.params.slug },
            query: { ...$route.query },
          }"
        >

          {{ $t('main.tab_list') }}
        </router-link>
        <router-link
          v-if="licensed"
          :class="{ active: false }"
          class="focus:outline-none"
          :to="{
            name: 'engravings_types',
            params: { slug: $route.params.slug },
            query: { ...$route.query },
          }"
        >
          {{ $t('main.tab_types') }}
        </router-link>
      </div>
    </div>
    <div class="content">
      <div>
        <ActionPanel
          @setType="setType"
          @copyDeletes="copyDeletes"
          @removeDeletes="removeDeletes"
          @blockDeletes="blockDeletes"
          @unblockDeletes="unblockDeletes"
          @setSort="setSort"
          :selectedSort="selectedSort"
          :selectedType="selectedType"
          :addLinkParams="{
            name: 'add_engraving',
            params: {
              slug: element_group && element_group.data.attributes.slug,
            },
            query: $route.query,
          }"
        />

        <div
          class="element-list table-list-wrapper wrapper-x-40"
          v-if="elements"
        >
              <table>
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        @change="changeCheck"
                      />
                    </th>
                    <th
                      class="image-name"
                      colspan="2"
                    >{{ $t('main.tab_list') }}:</th>
                    <th class="type">{{ $t('main.column_type') }}:</th>
                    <th class="status">{{ $t('main.column_status') }}:</th>
                    <th class="article">{{ $t('main.column_article') }}:</th>
                    <th class="min-price">{{ $t('main.column_min_price') }}:</th>
                    <th class="id">ID:</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="element in elements"
                    :key="element.data.element_id"
                  >
                    <td>
                      <input
                        type="checkbox"
                        ref="checkDeletes"
                        :value="element.data.element_id"
                        v-model="deletes"
                      />
                    </td>
                    <td class="image">
                      <router-link
                        class="image-preview dark-bg"
                        :to="{
                          name: 'edit_engraving',
                          params: {
                            slug: element_group.data.attributes.slug,
                            element_id: element.data.element_id,
                          },
                          query: $route.query
                        }"
                      ><img
                          :src="element.data.attributes.image"
                          :alt="element.data.attributes.name"
                        /></router-link>
                    </td>
                    <td class="name">
                      <router-link :to="{
                          name: 'edit_engraving',
                          params: {
                            slug: element_group.data.attributes.slug,
                            element_id: element.data.element_id,
                          },
                          query: $route.query
                        }">
                        {{ element.data.attributes.name }}
                      </router-link>
                    </td>
                    <td class="type">
                      {{
                        element.data.attributes.type &&
                        element.data.attributes.type.name
                      }}
                    </td>
                    <td class="status">
                      <button
                        @click="$store.dispatch('elements/block', { deletes: [element.data.element_id], status: 0 })"
                        class="text-green-500"
                        :title="$t('main.active')"
                        v-if="element.data.attributes.status"
                      ><i class="fas fa-check"></i></button>
                      <button
                        @click="$store.dispatch('elements/block', { deletes: [element.data.element_id], status: 1 })"
                        class="text-red-500"
                        :title="$t('main.not_active')"
                        v-else
                      ><i class="fa fa-lock"></i></button>
                    </td>
                    <td class="article">
                      {{ element.data.attributes.article }}
                    </td>
                    <td class="min-price">
                      {{
                        element.data.attributes.min_size &&
                        element.data.attributes.min_size.data.attributes.price
                          ? $toCurrency(
                              element.data.attributes.min_size.data.attributes
                                  .price
                          )
                          : ""
                      }}
                    </td>
                    <td class="id">{{ element.data.element_id }}</td>
                  </tr>
                </tbody>
              </table>
              <PaginationBar
                :meta="meta"
                :page="page"
                :per-page="parseInt(per_page)"
                :per-pages="perPages"
                @set-page="setPage"
                @set-per-page="setPerPage"
              />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionPanel from "../../../components/Admin/ActionPanel.vue";
import PaginationBar from "../../../components/Admin/PaginationBar.vue";
export default {
  name: "List",
  components: { ActionPanel, PaginationBar },
  data() {
    return {
      deletes: [],
    };
  },
  async created() {
    this.receiveQuery();
  },

  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
    elements() {
      return this.$store.state.elements.elements;
    },
    element_group() {
      return this.$store.state.elements.element_group;
    },
    meta() {
      return this.$store.state.elements.meta;
    },
    page() {
      return this.$store.state.elements.page;
    },
    per_page() {
      return this.$store.state.elements.per_page;
    },
    selectedType() {
      return this.$store.state.elements.type;
    },
    selectedSort() {
      return this.$store.state.elements.sort;
    },

    perPages() {
      return this.$store.state.settings.perPages;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    sorts() {
      return this.$store.state.settings.sorts;
    },
  },
  methods: {
    receiveQuery() {
      if (Object.hasOwnProperty.call(this.$route.query, "perPage")) {
        this.$store.dispatch("elements/setPerPage", this.$route.query.perPage);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "type")) {
        this.$store.dispatch("elements/setType", this.$route.query.type);
      }
      if (Object.hasOwnProperty.call(this.$route.query, "sort")) {
        const sort = this.sorts.find((s) => s.id == this.$route.query.sort);
        if (sort) {
          this.$store.dispatch("elements/setSort", sort);
        }
      }
      if (Object.hasOwnProperty.call(this.$route.query, "page")) {
        this.$store.dispatch("elements/setPage", this.$route.query.page);
      }
      this.$store.dispatch(
        "elements/fetch",
        this.element_group.data.attributes.slug
      );
    },
    setPage(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setType(type) {
      const query = {
        ...this.$route.query,
        type,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setSort(sort) {
      const query = {
        ...this.$route.query,
        sort,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    setPerPage(perPage) {
      const query = {
        ...this.$route.query,
        perPage,
      };

      this.$router
        .replace({ path: this.$route.path, query: { ...query } })
        .catch((error) => {});
    },
    changeCheck(event) {
      this.deletes = [];
      if (event.target.checked) {
        this.$refs.checkDeletes.map((check) => {
          check.checked = true;
          this.deletes.push(check.value);
        });
      } else {
        this.$refs.checkDeletes.map((check) => (check.checked = false));
      }
    },
    copyDeletes() {
      if (!this.deletes.length) {
        alert(this.$t("main.please_select_element"));
        return false;
      }
      this.$store.dispatch("elements/copy", this.deletes);
      this.deletes = [];
    },
    removeDeletes() {
      this.$store.dispatch("elements/remove", this.deletes);
      this.deletes = [];
    },
    blockDeletes() {
      this.$store.dispatch("elements/block", {
        deletes: this.deletes,
        status: 0,
      });
      this.deletes = [];
    },
    unblockDeletes() {
      this.$store.dispatch("elements/block", {
        deletes: this.deletes,
        status: 1,
      });
      this.deletes = [];
    },
  },
};
</script>
